import './app.css';
import App from './App.svelte';
import { initSentry } from './lib/sentry.ts';
import { mount } from 'svelte';

initSentry();

const app = mount(App, { target: document.getElementById('app')! });
export default app;
